import Sidebar from './components/Sidebar/Sidebar.css';
import Input from './components/Input/Input.css';
import Account from './components/Account/Account.css';
import UserCard from './components/UserCard/UserCard.css';
import TravellerForm from './components/TravellerForm/TravellerForm.css';
import Loyalty from './components/Loyalty/Loyalty.css';
import MilesHistory from './components/MilesHistory/MilesHistory.css';
import OrderCard from './components/OrderCard/OrderCard.css';
import PassengerSwitch from './components/Passenger/Switch/Switch.css';
import ActionButton from './components/Button/ActionButton/ActionButton.css';
import Modal from './components/Modal/Modal.css';
import Button from './components/Button/ActionButton/ActionButton.css';
import Select from './components/Passenger/Select/Select.css';
import LoyaltyInfo from './components/LoyaltyInfo/LoyaltyInfo.css';
import TicketExample from './components/TicketExample/TicketExample.css';
import LoginPage from './components/LoginPage/LoginPage.css';
const theme = {
    Passenger: {
        Switch: {
            element: PassengerSwitch.element,
            element_active: PassengerSwitch.element_active,
            element_error: PassengerSwitch.element_error
        },
        Select: {
            input: Select.input,
            input_standard: Select.input_standard,
            helperText: Select.helperText_account,
            icon: Select.icon
        }
    },
    Button: {
        ActionButton: {
            button: ActionButton.button
        },
        Button: {
            button: Button.button
        }
    },
    Modal: {
        Modal: {
            modal: Modal.modal
        }
    },
    Sidebar: {
        Sidebar: {
            link: Sidebar.link,
            sidebar: Sidebar.sidebar,
            sidebar__item: Sidebar.sidebar__item,
            item__text: Sidebar.item__text,
            icon: Sidebar.icon,
            sidebar__item_selected: Sidebar.sidebar__item_selected
        }
    },
    Input: {
        Input: {
            input_outline: Input.input_outline,
            input_filled: Input.input_filled,
            real_input: Input.real_input,
            disabled: Input.disabled,
            input: Input.input,
            textField__root: Input.textField__root,
            textField_focused: Input.textField_focused,
            textField_standard: Input.textField_standard,
            label_shrink: Input.label_shrink,
            input_focused: Input.input_focused,
            textField_filled: Input.textField_filled,
            input_error: Input.input_error,
            label_error: Input.label_error,
            underline: Input.underline,
            hint: Input.hint,
            hint_error: Input.hint_error
        }
    },
    Account: {
        InfoField: {
            field__button: Account.infoField__button,
            field__change: Account.infoField__change,
            field__connect: Account.infoField__connect
        }
    },
    AccountModule: {
        Account: {
            loginWrapper: Account.loginWrapper,
            route__title: Account.route__title,
            active__route: Account.active__route
        }
    },
    UserCard: {
        UserCard: {
            avatar: UserCard.avatar,
            empty: UserCard.empty,
            companion: UserCard.companion,
            name: UserCard.name
        }
    },
    Traveller: {
        Traveller: {
            popup__header: TravellerForm.traveller__header,
            wrapper: TravellerForm.traveller__wrapper
        }
    },
    TravelCompanions: {
        TravelCompanions: {
            companions: TravellerForm.companions
        }
    },
    LoyaltyInfo: {
        LoyaltyInfo: {
            miles: Loyalty.miles,
            progress: Loyalty.progress,
            progress_fares: Loyalty.progress_fares,
            content: Loyalty.content,
            links: Loyalty.links,
            button: Loyalty.button,
            button_gray: Loyalty.button_gray,
            footer: Loyalty.footer,
            text: Loyalty.text,
            modal_connect_paper: Loyalty.modal_connect_paper,
            modal_paper: Loyalty.modal_paper,
            progress_status: Loyalty.progress_status
        },
        Card: {
            wrapper: LoyaltyInfo.wrapper,
            authorized: LoyaltyInfo.authorized,
            nickel: LoyaltyInfo.nickel,
            gold: LoyaltyInfo.gold,
            base: Loyalty.base
        },
        LoyaltyCard: {
            header: Loyalty.loyaltyCard__header,
            number: Loyalty.number,
            wrapper: Loyalty.cardWrapper,
            simple: Loyalty.simple,
            gold: Loyalty.gold,
            platinum: Loyalty.platinum,
            nickel: Loyalty.nickel
        },
        SureModal: {
            button: Loyalty.modal_button
        }
    },
    Loyalty: {
        LoyaltyConnect: {
            button: Loyalty.button_connect,
            buttons__action: Loyalty.button_create
        },
        ForgotPassword: {
            controls: Loyalty.controls
        }
    },
    MilesHistory: {
        MilesHistory: {
            listHeader_item: MilesHistory.listHeader,
            label_accrued: MilesHistory.label_accrued,
            label_spent: MilesHistory.label_spent
        }
    },
    OrderCard: {
        OrderCard: {
            container: OrderCard.container,
            type_account: OrderCard.account,
            preview: OrderCard.preview
        },
        OrderPreview: {
            inner: OrderCard.preview__inner,
            city: OrderCard.city
        },
        OrderBooking: {
            orderCode: OrderCard.orderCode,
            type_account: OrderCard.type_account,
            icon: OrderCard.icon
        },
        CommonItem: {
            payload: OrderCard.payload
        }
    },
    OrderSummary: {
        OrderStub: {
            stub__background: Account.orderStub__background,
            stub__content: Account.orderStub__content
        }
    },
    TicketExample: {
        TicketExample: {
            ticketExample: TicketExample.ticketExample
        }
    },
    LoginPage: {
        CodeForm: {
            passwordAdornment: LoginPage.passwordAdornment
        }
    }
};
export default theme;
